import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"
import { Modal, Input, Row, Col, FormGroup, Label } from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"

const DependientUsersModal = props => {
  const { SearchBar } = Search

  const [page, setPage] = useState(undefined)
  const [sizePerPage, setSizePerPage] = useState(undefined)

  const users = (props.user?.users ?? []).filter(
    user => user.userId !== props.user?.userId
  )

  const columns = [
    {
      dataField: "userId",
      text: "Id",
      sort: false,
      hidden: true,
    },
    {
      dataField: "firstName",
      text: "Nombre",
      sort: true,
    },
    {
      dataField: "lastName",
      text: "Apellido",
      sort: true,
    },
    {
      dataField: "email",
      text: "Correo",
      sort: true,
    },
    {
      dataField: "profileId",
      text: "Perfil",
      sort: true,
      formatter: (column, row) => {
        return <div key={`profile-${row.userId}`}>N{row.profileId}</div>
      },
    },
  ]

  const pageOptions = {
    sizePerPage: sizePerPage === undefined ? 5 : sizePerPage,
    totalSize: users.length,
    custom: true,
    showTotal: true,
    page: page === undefined ? 1 : page,
    onPageChange: page => {
      setPage(page)
    },
    onSizePerPageChange: sizePerPage => {
      setSizePerPage(sizePerPage)
    },
  }

  const defaultSorted = [{ dataField: "userId", order: "asc" }]

  return (
    <Modal
      isOpen={props.show}
      size={"lg"}
      backdrop={"static"}
      id="staticBackdrop"
    >
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          Añadir usuarios al grupo
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            props.onCancel()
          }}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <PaginationProvider
          pagination={paginationFactory(pageOptions)}
          keyField="idUsuario"
          columns={columns}
          data={users}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="idUsuario"
              columns={columns}
              data={users}
              search
            >
              {toolkitProps => (
                <React.Fragment>
                  <Row className="mb-2 pt-3">
                    <Col>
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar
                            {...toolkitProps.searchProps}
                            onSearch={value => {
                              setPage(1)
                              toolkitProps.searchProps.onSearch(value)
                            }}
                            placeholder="Buscar"
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl="12">
                      <Fragment>
                        <BootstrapTable
                          keyField={"userId"}
                          bordered={false}
                          striped={true}
                          defaultSorted={defaultSorted}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                        {users.length <= 0 && (
                          <Row>
                            <Col md={12} className="text-center">
                              -- No hay usuarios dependientes --
                            </Col>
                          </Row>
                        )}
                      </Fragment>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => {
            props.onCancel()
          }}
        >
          Salir
        </button>
      </div>
    </Modal>
  )
}

DependientUsersModal.propTypes = {
  show: PropTypes.bool,
  user: PropTypes.object,
  onCancel: PropTypes.func,
}

export default DependientUsersModal
